<template>
  <div>
    <!-- Sidebar Component -->
    <Sidebar
      :width="900"
      id="customer-sales-sidebar"
      title="Previous Customer Sales"
      right
    >
      <b-row>
        <b-col cols="6"></b-col>
        <b-col cols="6" class="float-end">
          <input
            type="string"
            class="form-control"
            placeholder="search"
            style="margin-bottom: 10px; border-radius: 10px"
            v-model="query"
            @input="fetchSales"
          /> </b-col
      ></b-row>
      <b-row
        v-if="customerSales.length == 0 && !loading"
        class="pl-3 pr-3 text-center"
      >
        <b-col>
          <b-alert show variant="warning">No Sales Found</b-alert>
        </b-col>
      </b-row>
      <!-- Sale List -->
      <b-row v-if="customerSales.length != 0 && !loading">
        <b-col cols="12" class="text-center">
          <table class="table table-hover table-striped">
            <tbody>
              <tr>
                <th class="text-center">Reference Number</th>
                <th class="text-center">Date</th>
                <th class="text-center">Amount</th>
                <th class="text-center">Number of Items</th>
                <th class="text-center">Shop</th>
              
              </tr>
              <tr
                v-for="(item, index) in customerSales"
                :key="index"
                style="border-bottom: 1px solid #c1c1c1"
              >
                <td class="text-center">{{ item.reference_number }}</td>
                <td class="text-center">
                  {{ moment(item.date) }}
                </td>
                <td class="text-center">{{ item.grand_total }}</td>
                <td class="text-center">{{ item.total_items }}</td>
                <td class="text-center">{{ item.shop.name }}</td>
              
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </Sidebar>
  </div>
</template>

<script>
// Components
import Sidebar from "@/components/base/Sidebar";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "CustomerPreviousSales",

  data: () => ({
    // sales Return Visible
    salesReturnVisible: false,
  }),
  components: {
    Sidebar,
  },
  methods: {
  
    moment: function(date) {
      return moment(date).format("LL");
    },
    fetchSales() {
      this.$store.dispatch("sales/fetchCustomerSales", {
        query: this.query,
        customer: this.customer.id,
      });
    },
  },
  props: {
    data: {
      type: Object,
        default: () => ({})
    },
  },
  data: () => ({
    loading: null,
    query: null,
  }),
  computed: {
    ...mapState("sales", ["customerSales"]),
    ...mapState("bill", ["customer"]),
  },
  mounted() {
    this.fetchSales();
  },
};
</script>
<style scoped>
.returnButton {
  height: 29px;
  width: 62px;
  color: white;
  background: blueviolet;
  border-radius: 17px;
  border: antiquewhite;
}
</style>
